export default __webpack_public_path__ + "static/media/rewards-image.aa77c53a.svg";